class AccordionMenu {
	constructor(menuElement) {
		this.menuElement = menuElement;
		this.menuItems = this.menuElement.querySelectorAll('.menu-item');

		this.addEventListeners();
	}

	addEventListeners() {
		this.menuItems.forEach((menuItem) => {
			const hasChildren = menuItem.classList.contains('menu-item-has-children');
			if (hasChildren) {
				const link = menuItem.querySelector('a');
				const subMenu = new SubMenu(menuItem);
			}
		});
	}

	toggleSubMenu(menuItem, event) {
		event.preventDefault();
		const subMenu = menuItem.querySelector('.sub-menu');
		subMenu.classList.toggle('active');
		// subMenu.style.transition = this.transition;
		subMenu.style.maxHeight = subMenu.scrollHeight + "px";
	}
}

class SubMenu {
	constructor(el) {
		this.el = el;
		this.subMenu = el.querySelector('.sub-menu');
		this.link = el.querySelector('a');
		this.isOpen = false;

		this.subMenu.setAttribute('hidden', '');
		this.initButton();
	}

	initButton() {
		//swap the link element over to a button
		const button = document.createElement('button');
		button.classList.add('sub-menu-toggle');
		button.setAttribute('aria-expanded', 'false');
		button.setAttribute('aria-controls', this.subMenu.id);
		button.innerHTML = this.link.innerHTML;
		this.link.parentNode.replaceChild(button, this.link);
		this.button = button;

		// add event listeners
		this.button.addEventListener("click", this.onButtonClick.bind(this));
	}

	onButtonClick() {
		this.toggle(!this.isOpen);
	}

	toggle(open) {
		// don't do anything if the open state doesn't change
		if (open === this.isOpen) {
			return;
		}

		// update the internal state
		this.isOpen = open;

		// handle DOM updates
		this.subMenu.setAttribute("aria-expanded", `${open}`);
		this.button.setAttribute("aria-expanded", `${open}`);

		if (open) {
			this.el.classList.add("active");
			this.subMenu.classList.add("active");

			// Handle button
			this.button.classList.add("active");

			// Handle content
			this.subMenu.removeAttribute("hidden");
			// this.subMenu.style.transition = this.transition;
			this.subMenu.style.maxHeight = this.subMenu.scrollHeight + "px";
		} else {
			this.el.classList.remove("active");
			this.subMenu.classList.remove("active");

			// Handle button
			this.button.classList.remove("active");

			// Handle content
			this.subMenu.style.maxHeight = null;
			this.subMenu.addEventListener(
				"transitionend",
				() => {
					this.subMenu.setAttribute("hidden", "");
				},
				{ once: true }
			);
		}
	}

	open() {
		this.toggle(true);
	}

	close() {
		this.toggle(false);
	}
}

// Init accordion menus
const accordions = document.querySelectorAll("[data-accordion-menu]");
accordions.forEach((accordionEl) => {
	new AccordionMenu(accordionEl);
});
